import { Grid } from '@mui/material';

import { ActivityDetailSkeletonCard } from '@/components/ActivityDetails';
import { AttendeesCardListSkeleton } from '@/components/Attendee/AttendeesCardListSkeleton';
import { CoOrganizerCardListSkeleton } from '@/components/CoOrganizer';
import { DetailPageLayout } from '@/components/DetailPageLayout';
import { MediaSkeletonStaticBlock } from '@/components/Media';
import { PageHeaderSkeleton } from '@/components/PageHeader';
import {
  CommentsSkeletonStaticBlock,
  KeyMessagesSkeletonStaticBlock,
} from '@/views/Activity';
import { TopicsStaticBlockSkeleton } from '@/views/Activity/Read';
import { PromotionalMaterialSkeletonStaticBlock } from '@/views/Interaction/Overview';

export const ActivitySkeleton = () => {
  return (
    <DetailPageLayout
      headerComp={<PageHeaderSkeleton showSubtitle />}
      firstColumnComp={
        <>
          <Grid>
            <ActivityDetailSkeletonCard />
          </Grid>
          <Grid>
            <AttendeesCardListSkeleton />
          </Grid>
          <Grid>
            <CoOrganizerCardListSkeleton />
          </Grid>
        </>
      }
      middleColumnComp={
        <>
          <Grid>
            <TopicsStaticBlockSkeleton />
          </Grid>
          <Grid>
            <MediaSkeletonStaticBlock />
          </Grid>
          <Grid>
            <PromotionalMaterialSkeletonStaticBlock />
          </Grid>
        </>
      }
      lastColumnComp={
        <>
          <Grid>
            <KeyMessagesSkeletonStaticBlock />
          </Grid>
          <Grid>
            <CommentsSkeletonStaticBlock />
          </Grid>
        </>
      }
    />
  );
};
